'use strict';

/**
 * Фиксированный хедер с функцией сворчанивания при скроле
 * @module
 */

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * @param {string} [selector=".js-navpanel"]- поиск элементов по селектору
 * @sourceCode
 */
(function ($) {
	// set scrolling variables
	let scrolling = false;
	let previousTop = 0;
	let scrollDelta = 5;
	let scrollOffset = 50;
	let $selector = $('.js-navpanel');
	let $body = $('body');
	let $window = $(window);

	$window.on('scroll', function () {
		if (!scrolling) {
			scrolling = true;
			(!window.requestAnimationFrame)
				? setTimeout(autoHideHeader, 250)
				: window.requestAnimationFrame(autoHideHeader);
		}
	});

	autoHideHeader();

	function autoHideHeader () {
		let currentTop = $window.scrollTop();

		if (previousTop - currentTop > scrollDelta) {
			$body.addClass('show-header');
		} else if (currentTop - previousTop > scrollDelta && currentTop > scrollOffset) {
			$body.addClass('show-w');
			$body.removeClass('show-header');
		}

		if (currentTop < scrollOffset) {
			$body.removeClass('show-header show-w');
		}

		previousTop = currentTop;
		scrolling = false;
	}
})(window.jQuery);



// WEBPACK FOOTER //
// ./src/js/_modules/navpanel.js